import {Col, FormCheck, FormControl, Row} from "react-bootstrap";
import React from "react";
import {Glyph} from "../common/Glyph";
import {SuperbillDxInput} from "./SuperbillDxInput";
import {SuperbillOtherInput} from "./SuperbillOtherInput";
import {nlToBr} from "../../utils/Strings";
import moment from "moment-timezone";
import CalendarButton from "../common/CalendarButton";

export class SuperbillOrderItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            collapsed: !this.props.value
        }
    }

    itemChanged = (e) => {
        /**
         * itemChanged={(checked) => this.orderChanged(o.id, checked)}
         *  optionChanged={(optionId, value) => this.optionChanged(o.id, optionId, value)
         */
        let checked = e.target.checked;
        this.props.itemChanged(checked);
        if (checked && this.state.collapsed) {
            this.setState({collapsed: false});
        } else if (!checked && !this.state.collapsed) {
            this.setState({collapsed: true});
        }
    }

    isOptionSelected = (optionId) => {
        let val = this.getOptionValue(optionId);
        // allow blank value = selected
        return (val || val === "");
    }

    getOptionValue = (optionId) => {
        let val = this.props.value;
        if (val && val.options) {
            let option = val.options.find(o => o.optionId == optionId);
            if (option) {
                return option.value;
            }
        }
        return null;
    }

    getOptionDueDate = (optionId) => {
        let val = this.props.value;
        if (val && val.options) {
            let option = val.options.find(o => o.optionId == optionId);
            if (option) {
                return option.optionDueDate || null;
            }
        }
        return null;
    }

    getOptionDueDateFormatted = (optionId) => {
        let dt = this.getOptionDueDate(optionId);
        return dt ? <small className={"ml-2"}>{moment(dt).format("M/D/YY")}</small> : "";
    }

    getOrderDueDateFormatted = () => {
        let dt = this.props.dueDate;
        return dt ? <small className={"ml-2"}>{moment(dt).format("M/D/YY")}</small> : "";
    }

    getOptionDueDateForPrint = (optionId) => {
        let dt = this.getOptionDueDate(optionId);
        return dt ? `(Due ${moment(dt).format("M/D/YY")})` : "";
    }

    getOrderDueDateForPrint = () => {
        let dt = this.props.dueDate;
        return dt ? `(Due ${moment(dt).format("M/D/YY")})` : "";
    }

    getOptionDueDateButton = (optionId) => {
        if (this.props.disabled) return <></>

        let dt = this.getOptionDueDate(optionId)
        return dt ? <Glyph name={"x-circle"} className={"clickable no-print"} onClick={() => this.props.optionDueDateChanged(optionId, null)}/>
            : <CalendarButton selected={dt}
                               onChange={(d) => this.props.optionDueDateChanged(optionId, d)}/>
    }

    getOrderDueDateButton = () => {
        if (this.props.disabled) return <></>

        let dt = this.props.dueDate;
        return dt ? <Glyph name={"x-circle"} className={"clickable no-print"} onClick={() => this.props.dueDateChanged(null)}/>
            : <CalendarButton selected={dt}
                               onChange={(d) => this.props.dueDateChanged(d)}/>
    }

    getOptionDx = (optionId) => {
        let val = this.props.value;
        if (val && val.options) {
            let option = val.options.find(o => o.optionId == optionId);
            if (option) {
                return option.dx;
            }
        }
        return null;
    }

    getOptionDisplayValue = (o) => {
        let val = this.getOptionValue(o.optionId);
        let dx = this.getOptionDx(o.optionId);
        switch(o.type) {
            case "BOOL":
                return val ? o.optionName + (dx ? "; DX: "+dx : "") : "";
            case "DX":
                return "DX: " + val;
            default:
                return o.optionName + (val ? ": " + val : "") + (dx ? "; DX: "+dx : "");
        }
    }

    isOptionSuggested = (optionId) => {
        let sugg = this.props.suggestedOptions;
        if (sugg && sugg.some(o => o.optionId == optionId)) {
            return true;
        }
        return false;
    }

    getSuggestionLabel = () => {
        let label = null;
        if (this.props.suggested) {
            let sugg = this.props.suggested;
            if (sugg.icds && sugg.icds.length > 0) {
                label = nlToBr(`Suggestion based on:\n${
                    sugg.icds.map(i => `${i.icd10Code} ${i.description}`).join('\n')
                }`);
            } else if (sugg.lastAppt) {
                label = `Pt had an appointment for this test on ${moment(sugg.lastAppt).format('M/D/YY')}.`;
            }
        }
        return label;
    }

    render() {
        let meta = this.props.metadata;
        let options = meta.options || [];
        if (!this.props.diagnoses || this.props.diagnoses.length == 0) {
            // Filter out any DX options - no diagnoses present
            options = options.filter(o => o.type != "DX");
        }
        let val = this.props.value;
        let selectedOptions = options.filter(o => o.type != "DX" && this.getOptionValue(o.optionId) != null);
        let dxValues = options.filter(o => o.type == "DX" && this.getOptionValue(o.optionId) != null);
        let readOnly = this.props.displayOnly;

        return <><Row>
            <Col sm={10}>
                {
                    readOnly ? <>{meta.name} {this.getOrderDueDateForPrint()}</>
                        : <FormCheck type={"checkbox"} label={meta.name} className={`d-inline-block ${!readOnly && this.props.suggested ? "superbill-suggested-item" : ""}`} onChange={this.itemChanged} checked={(val != null)}/>
                }
                {
                    !readOnly && this.props.suggested && <>
                        <Glyph name={"stars"} className={"ml-2 text-success"} label={this.getSuggestionLabel()} showLabelOnClick={true}/>
                        {this.props.suggested.lastAppt && <small><i>{` Last Appt: ${moment(this.props.suggested.lastAppt).format('M/D/YY')}`}</i></small>}
                    </>
                }
                {
                    this.state.collapsed && selectedOptions.length > 0 && <>  [
                        { selectedOptions.map(o => this.getOptionDisplayValue(o)).join(', ') }
                    ]</>
                }
                {
                    this.state.collapsed && dxValues.length > 0 && <>  [
                        { dxValues.map(o => this.getOptionDisplayValue(o)).join(', ') }
                    ]</>
                }
            </Col>
            <Col sm={2} className={"no-print"}>
                {this.props.value && meta.supportsDueDate ? <>
                    {this.getOrderDueDateButton()}
                    {this.getOrderDueDateFormatted()}
                </> : <></>}
            </Col>

        </Row>
        {
            !readOnly && options && options.length > 0 && !this.state.collapsed && options.map(o => <Row key={meta.name + o.optionName} className={this.state.collapsed ? "invisible" : "mb-1"}>
                <Col>
                    {
                        o.type == "DX" && this.props.diagnoses && this.props.diagnoses.length > 0 &&
                        <Row className={"ml-3"}><Col sm={12} lg={6}><SuperbillDxInput allIcds={this.props.diagnoses} value={this.getOptionValue(o.optionId)} onDxChanged={(csv) => this.props.optionChanged(o.optionId, csv)}/></Col></Row>
                    }
                    {
                        o.type == "BOOL" && <Row className={"ml-2"}>
                            <Col sm={6}>
                                <FormCheck type={"checkbox"} label={o.optionName} checked={new String(this.getOptionValue(o.optionId)) == "true"}
                                           className={`d-inline-block ${this.isOptionSuggested(o.optionId) ? "superbill-suggested-item" : ""}`}
                                           onChange={(e) => this.props.optionChanged(o.optionId, e.target.checked)}
                                            disabled={this.props.displayOnly || this.props.disabled}/>
                                {
                                    this.isOptionSuggested(o.optionId) && <Glyph name={"stars"} className={"ml-2 text-success"}/>
                                }
                                {
                                    o.flags && o.flags.map(f => <Glyph key={f.iconName+o.optionId} name={f.iconName} label={f.label || ""} className={"ml-2 " + (f.className || "")} style={f.iconColor ? {color: f.iconColor} : null}/>)
                                }
                            </Col>
                            <Col sm={4}>
                                {o.supportsDx && this.isOptionSelected(o.optionId) ? <SuperbillDxInput allIcds={this.props.diagnoses} value={this.getOptionDx(o.optionId)} onDxChanged={(csv) => this.props.optionDxChanged(o.optionId, csv)} disabled={this.props.displayOnly || this.props.disabled}/> : <></>}
                            </Col>
                            <Col sm={2}>
                                {o.optionSupportsDueDate && this.isOptionSelected(o.optionId) ? <>
                                    {this.getOptionDueDateButton(o.optionId)}
                                    {this.getOptionDueDateFormatted(o.optionId)}
                                </> : <></>}
                            </Col>
                        </Row>
                    }

                    {
                        o.type == "OTHER" &&<Row className={"ml-2"}>
                            <Col sm={6}>
                                <SuperbillOtherInput label={o.optionName} value={this.getOptionValue(o.optionId)} onValueChanged={(val) => this.props.optionChanged(o.optionId, val)}/>
                            </Col>
                            <Col sm={5}>
                                {o.supportsDx && this.isOptionSelected(o.optionId) ? <SuperbillDxInput allIcds={this.props.diagnoses} value={this.getOptionDx(o.optionId)}
                                                   onDxChanged={(csv) => this.props.optionDxChanged(o.optionId, csv)}/> : <></>}
                            </Col>
                            <Col sm={2}>
                                {o.optionSupportsDueDate && this.isOptionSelected(o.optionId) ? <>
                                    {this.getOptionDueDateButton(o.optionId)}
                                    {this.getOptionDueDateFormatted(o.optionId)}
                                </> : <></>}
                            </Col>
                        </Row>

                    }
                </Col>
            </Row>)
        }
        {
            readOnly && options && options.length > 0 && <Row><Col><ul>
                {
                    options.filter(o => this.getOptionValue(o.optionId) != null && new String(this.getOptionValue(o.optionId)) != "false")
                        .map(o => <li key={o.optionId}>{this.getOptionDisplayValue(o)} {this.getOptionDueDateForPrint(o.optionId)}</li>)
                }
            </ul></Col></Row>
        }
        </>
    }
}